import { render, staticRenderFns } from "./retelllecture.vue?vue&type=template&id=fabe246e&scoped=true&"
import script from "./retelllecture.vue?vue&type=script&lang=js&"
export * from "./retelllecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabe246e",
  null
  
)

export default component.exports